var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "학력",
      fn: function () {
        return [_c('form-qualification-education', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.qualification,
            callback: function ($$v) {
              _vm.$set(_vm.form, "qualification", $$v);
            },
            expression: "form.qualification"
          }
        })];
      },
      proxy: true
    }, {
      key: "경력",
      fn: function () {
        return [_c('form-qualification-experience', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.qualification,
            callback: function ($$v) {
              _vm.$set(_vm.form, "qualification", $$v);
            },
            expression: "form.qualification"
          }
        })];
      },
      proxy: true
    }, {
      key: "연령",
      fn: function () {
        return [_c('form-qualification-age', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.qualification,
            callback: function ($$v) {
              _vm.$set(_vm.form, "qualification", $$v);
            },
            expression: "form.qualification"
          }
        })];
      },
      proxy: true
    }, {
      key: "성별",
      fn: function () {
        return [_c('form-qualification-gender', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.qualification,
            callback: function ($$v) {
              _vm.$set(_vm.form, "qualification", $$v);
            },
            expression: "form.qualification"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }